/* eslint-disable react/jsx-props-no-spreading */
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import * as AppPropTypes from '../../../lib/PropTypes';

import { useThemeClassName } from '../../../contexts/ThemeContext';
import Logo from '../../icons/Logo';

import styles from '../../../../styles/displays/banners/ad.module.scss';

const propTypes = {
    title: PropTypes.string,
    siteUrl: PropTypes.string,
    image: AppPropTypes.image,
    logoComponent: PropTypes.string,
    vertical: PropTypes.bool,
};

const defaultProps = {
    title: null,
    image: null,
    siteUrl: null,
    logoComponent: null,
    vertical: false,
};

function Ad({ title, image, siteUrl, logoComponent, vertical }) {
    const themeClassName = useThemeClassName(styles);

    return (
        <div
            className={classNames([
                styles.container,
                {
                    [styles.vertical]: vertical,
                },
                themeClassName,
            ])}
        >
            <div className={styles.inner}>
                <div className={styles.content}>
                    <h2 className={styles.title}>
                        {title !== null ? (
                            title
                        ) : (
                            <FormattedMessage
                                defaultMessage="Come play with us at"
                                description="Banner message"
                            />
                        )}
                    </h2>
                    {siteUrl ? (
                        <h3
                            className={classNames([
                                styles.url,
                                {
                                    [styles.long]: siteUrl.length > 15,
                                },
                            ])}
                        >
                            {siteUrl}
                        </h3>
                    ) : null}
                </div>
                {/* @TODO: Implement image */}
                <div className={styles.imageContainer}>
                    {image !== null ? (
                        <img
                            className={styles.image}
                            src="https://designshack.net/wp-content/uploads/placehold.jpg"
                            alt=""
                        />
                    ) : (
                        <Logo component={logoComponent} className={styles.logo} />
                    )}
                </div>
            </div>
        </div>
    );
}

Ad.propTypes = propTypes;
Ad.defaultProps = defaultProps;

export default Ad;
